/*
 * @Author: Yun 
 * @Date: 2025-09-24 13:57:14 
 * @Last Modified by: Yun
 * @Last Modified time: 2025-12-31 18:54:01
 */

import logo from '@assets/images/cgtn.png';
import heroBg1 from '@assets/images/hero/bg1.png';
import heroBg2 from '@assets/images/hero/bg2.png';
import videocover from '@assets/images/videocover.jpg';
import heroSlice1 from '@assets/images/highlight/img1.png';
import heroSlice2 from '@assets/images/highlight/img2.jpg';
import heroSlice3 from '@assets/images/highlight/img3.jpg';
import heroSlice4 from '@assets/images/highlight/img4.jpg';
import heroSlice5 from '@assets/images/highlight/img5.jpg';
import timelineMountain from '@assets/images/timeline/1.png';
import timelineCloud1 from '@assets/images/timeline/cloud1.png';
import timelineCloud2 from '@assets/images/timeline/cloud2.png';
import timelineTreemap from '@assets/images/timeline/treemap.jpg';
import timelineTreemapMobile from '@assets/images/timeline/treemap_m.jpg';
import timelineBg from '@assets/images/timeline/bg.png';
import timelinePointer from '@assets/images/timeline/pointer.png';
import productBg from '@assets/images/product/bg.jpg';
// 字体文件导入
import HONORSansBold from '@assets/fonts/HONORSans/HONORSans-Bold.ttf';
import HONORSansDemibold from '@assets/fonts/HONORSans/HONORSans-Demibold.ttf';
import HONORSansExtraBold from '@assets/fonts/HONORSans/HONORSans-ExtraBold.ttf';
import HONORSansExtraLight from '@assets/fonts/HONORSans/HONORSans-ExtraLight.ttf';
import HONORSansHeavy from '@assets/fonts/HONORSans/HONORSans-Heavy.ttf';
import HONORSansLight from '@assets/fonts/HONORSans/HONORSans-Light.ttf';
import HONORSansMedium from '@assets/fonts/HONORSans/HONORSans-Medium.ttf';
import HONORSansRegular from '@assets/fonts/HONORSans/HONORSans-Regular.ttf';
import HONORSansThin from '@assets/fonts/HONORSans/HONORSans-Thin.ttf';

export interface PreloadAsset {
  id: string;
  url: string;
  size: number;
  priority: 'high' | 'medium' | 'low';
  type?: 'image' | 'font' | 'video';
  description?: string;
}

export const preloadAssets: PreloadAsset[] = [
  // 字体文件 - 最高优先级
  {
    id: 'font-honor-sans-regular',
    url: HONORSansRegular,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Regular字体'
  },
  {
    id: 'font-honor-sans-medium',
    url: HONORSansMedium,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Medium字体'
  },
  {
    id: 'font-honor-sans-bold',
    url: HONORSansBold,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Bold字体'
  },
  {
    id: 'font-honor-sans-demibold',
    url: HONORSansDemibold,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Demibold字体'
  },
  {
    id: 'font-honor-sans-extrabold',
    url: HONORSansExtraBold,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans ExtraBold字体'
  },
  {
    id: 'font-honor-sans-extralight',
    url: HONORSansExtraLight,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans ExtraLight字体'
  },
  {
    id: 'font-honor-sans-heavy',
    url: HONORSansHeavy,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Heavy字体'
  },
  {
    id: 'font-honor-sans-light',
    url: HONORSansLight,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Light字体'
  },
  {
    id: 'font-honor-sans-thin',
    url: HONORSansThin,
    size: 150,
    priority: 'high',
    type: 'font',
    description: 'HONOR Sans Thin字体'
  },
  {
    id: 'logo',
    url: logo,
    size: 100,
    priority: 'high',
    description: '网站Logo'
  },
  {
    id: 'hero-bg1',
    url: heroBg1,
    size: 800,
    priority: 'high',
    description: 'Hero背景图1'
  },
  {
    id: 'hero-bg2', 
    url: heroBg2,
    size: 800,
    priority: 'high',
    description: 'Hero背景图2'
  },

  {
    id: 'hero-video-poster',
    url: videocover,
    size: 300,
    priority: 'high',
    description: 'Hero视频封面'
  },
  // 注意：视频预加载已移除，因为：
  // 1. 视频文件可能有跨域限制，无法通过 <video> 标签预加载
  // 2. JWPlayer 会自己处理视频加载和缓冲
  // 3. 视频封面图已经预加载，可以在视频加载时显示
  /* {
    id: 'hero-video',
    url: 'https://video.cgtn.com/news/2023-12-31/President-Xi-Jinping-delivers-2024-New-Year-Message-1pZ8L8Cd4pG/video/320c559d6c6345fa980372bc8cfbb74c/320c559d6c6345fa980372bc8cfbb74c.mp4',
    size: 500,
    priority: 'high',
    type: 'video',
    description: 'Hero视频（预加载元数据）'
  }, */
  {
    id: 'hero-slice1',
    url: heroSlice1,
    size: 400,
    priority: 'high',
    description: 'Hero开屏切片1'
  },
  {
    id: 'hero-slice2',
    url: heroSlice2,
    size: 400,
    priority: 'high',
    description: 'Hero开屏切片2'
  },
  {
    id: 'hero-slice3',
    url: heroSlice3,
    size: 400,
    priority: 'high',
    description: 'Hero开屏切片3'
  },
  {
    id: 'hero-slice4',
    url: heroSlice4,
    size: 400,
    priority: 'high',
    description: 'Hero开屏切片4'
  },
  {
    id: 'hero-slice5',
    url: heroSlice5,
    size: 400,
    priority: 'high',
    description: 'Hero开屏切片5'
  },
  {
    id: 'timeline-mountain',
    url: timelineMountain,
    size: 600,
    priority: 'high',
    description: 'TimeLine山脉背景'
  },
  {
    id: 'timeline-cloud1',
    url: timelineCloud1,
    size: 200,
    priority: 'high',
    description: 'TimeLine云彩1'
  },
  {
    id: 'timeline-cloud2',
    url: timelineCloud2,
    size: 200,
    priority: 'high',
    description: 'TimeLine云彩2'
  },
  {
    id: 'timeline-treemap',
    url: timelineTreemap,
    size: 300,
    priority: 'high',
    description: 'TimeLine热力词树图'
  },
  {
    id: 'timeline-treemap-mobile',
    url: timelineTreemapMobile,
    size: 200,
    priority: 'high',
    description: 'TimeLine热力词树图（移动端）'
  },
  {
    id: 'timeline-bg',
    url: timelineBg,
    size: 400,
    priority: 'high',
    description: 'TimeLine交互区域背景'
  },
  {
    id: 'timeline-pointer',
    url: timelinePointer,
    size: 50,
    priority: 'high',
    description: 'TimeLine指针'
  },
  {
    id: 'product-bg',
    url: productBg,
    size: 800,
    priority: 'medium',
    description: 'Product背景图'
  },
];

/**
 * 获取指定优先级的资源
 */
export const getAssetsByPriority = (priority: 'high' | 'medium' | 'low'): PreloadAsset[] => {
  return preloadAssets.filter(asset => asset.priority === priority);
};

/**
 * 计算总文件大小
 */
export const getTotalSize = (): number => {
  return preloadAssets.reduce((total, asset) => total + asset.size, 0);
};

